import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { Mask } from '../mask.interface';
import { Validation } from '../validation.interface';
import { FormControl } from '@angular/forms';

export class MeepCardNameModel implements Validation, Mask {

  static MEEP_CARD_NAME = 'meepCardName';
  static MEEP_CARD_NAME_ERROR_DESCRIPTION = 'Digite entre 4 e 20 caracteres';

  static meepCardNameValidation(input: FormControl) {
    if (input.value) {
      if (input.value.length > 20 || input.value.length < 4) {
        return { [MeepCardNameModel.MEEP_CARD_NAME]: true, description: 'Invalid size' };
      }
      return null;
    } else {
      return { [MeepCardNameModel.MEEP_CARD_NAME]: true, description: 'Invalid field' };
    }
  }

  private meepCardNameMask = (_value: string): (string | RegExp)[] | Function | boolean => {
    const value = _value.replace(/[^A-Za-z\d]/g, '');
    const mask = [];
    for (let i = 0; i < value.length; i++) {
      mask.push(/[A-Za-z0-9]/);
    }
    return mask;
  }

  getMaskRule(): boolean | Function | (string | RegExp)[] {
    return this.meepCardNameMask;
  }

  getValidatorsName(): string {
    return MeepCardNameModel.MEEP_CARD_NAME;
  }
  getValidatorsErrorDescription(): string {
    return MeepCardNameModel.MEEP_CARD_NAME_ERROR_DESCRIPTION;
  }
  getValidatorsRule(): ValidatorFn {
    return MeepCardNameModel.meepCardNameValidation;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/meepCardName.model.ts